import React from 'react';
import {useGlobalContext} from "../../../../../app/modules/_common/contexts/GlobalContext";
import classnames from "classnames";
import {useHeader} from '../../../_core/HeaderProvider';
import UserDropdown from '../../../../../app/modules/_common/components/UserDropdown';
import styles from './styles.module.scss';

export default function Header() {
  const header = useHeader();
  const {isGlassTheme} = useGlobalContext();

  return (
    <div
      className={classnames(
        'header',
        styles.header,
        isGlassTheme ? styles.filter : styles.noFilter
      )}
      id="kt_header"
    >
      <div className="w-100 d-flex align-items-center">
        <h1 className="font-weight-bolder mb-0" style={{marginRight: 300}}>{header.title}</h1>
      </div>
      <UserDropdown/>
    </div>
  );
}